import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Users,
  PartyPopper,
  Gem,
  Sparkles,
  Sunset,
  Video,
  CalendarHeart,
  Gift,
} from "lucide-react";
import { Camera, Heart, ShipWheel, Music, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";
import SEO from "../Components/SEO";
import { SEO_DATA } from "../config/seoData";

const prewedFaqs = [
  {
    question: "What is a pre-wedding yacht photoshoot in Mumbai like?",
    answer:
      "A pre-wedding yacht photoshoot in Mumbai is a private couple shoot on the water with sea views, elegant yacht backdrops and a more exclusive atmosphere."
  },
  {
    question: "Is a yacht a good venue for a pre-wedding shoot?",
    answer:
      "Yes. A yacht offers a premium, romantic and scenic backdrop that makes couple photos feel more elegant and memorable."
  },
  {
    question: "What can we capture during a yacht photoshoot?",
    answer:
      "Couples often capture portraits, candid moments, sunset shots, romantic videos, save-the-date content and engagement-style visuals."
  },
  {
    question: "Is a private yacht better for a couple shoot?",
    answer:
      "Yes. For most couples, a private yacht charter creates a more intimate and relaxed environment for the shoot."
  },
  {
    question: "Can a larger group join the photoshoot?",
    answer:
      "Yes. If your shoot includes a larger group or additional setup requirements, a bigger yacht option may be more suitable."
  },
  {
    question: "How is Indiaboats different for pre-wedding yacht shoots?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps couples choose the right yacht format for a visually beautiful and smooth experience."
  },
  {
    question: "What is the best time for a pre-wedding yacht photoshoot?",
    answer:
      "Many couples prefer golden hour and sunset because the natural light and sea backdrop create softer, more romantic images."
  },
  {
    question: "How do I enquire about a pre-wedding yacht photoshoot in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your preferred date, expected group size and shoot requirements."
  }
];

const PreWedding = () => {
  

 const benefitsList = [
  "Premium yacht photoshoot experience in Mumbai",
  "Romantic private setting for couples",
  "Beautiful sea and skyline backdrop",
  "Ideal for pre-wedding shoots and engagement content",
  "More exclusive than crowded public locations",
  "Guidance on choosing the right yacht format",
  "Memorable and visually elevated experience",
];

 const outcomes = [
  {
    text: "Romantic Couple Portraits",
    description:
      "Capture elegant couple portraits on the yacht deck with beautiful sea views and a premium setting.",
    icon: <Camera size={20} />,
  },
  {
    text: "Save-the-Date Content",
    description:
      "Create stunning save-the-date and wedding announcement photos that feel unique and memorable.",
    icon: <CalendarHeart size={20} />,
  },
  {
    text: "Candid Couple Moments",
    description:
      "Capture natural moments together with the sea and Mumbai skyline as your backdrop.",
    icon: <Heart size={20} />,
  },
  {
    text: "Golden Hour Photography",
    description:
      "Take breathtaking sunset photos using the warm natural light over the Arabian Sea.",
    icon: <Sunset size={20} />,
  },
  {
    text: "Romantic Reels & Videos",
    description:
      "Film cinematic romantic reels and short videos in a scenic on-water environment.",
    icon: <Video size={20} />,
  },
  {
    text: "Proposal-Style Moments",
    description:
      "Capture intimate proposal-inspired moments that feel genuine, elegant and timeless.",
    icon: <Gem size={20} />,
  },
  {
    text: "Luxury Yacht Backdrop",
    description:
      "Use the yacht itself as a premium backdrop for sophisticated couple portraits.",
    icon: <ShipWheel size={20} />,
  },
  {
    text: "Luxury Wedding Content",
    description:
      "Create high-end wedding-inspired content on the water with a luxurious atmosphere.",
    icon: <Sparkles size={20} />,
  },
];

  return (
    <div>
      <SEO {...SEO_DATA.preWedding} />
      <IndiaBoatsTopBar />
      <PremiumNavbar />

       <section className="clsm-mid-root-wrapper">
      
      <div className="clsm-mid-bg-image" style={{backgroundImage: "url('/assets/img/prewedding1.png')" }}></div>
      
     
      <div className="clsm-mid-bg-gradient-overlay"></div>

      <div className="clsm-mid-container">
        
        {}
        <div className="clsm-mid-header">
         <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              A Romantic Pre-Wedding Shoot  <br />
              <span className="csrh-title-italic">
                  on the Water
              </span>
            </h1>
           
          </div>
          <div className="clsm-mid-decorative-line"></div>
        </div>

        {}
        <div className="clsm-mid-editorial-grid">
          {/* Left Column Paragraph */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
              A pre-wedding yacht photoshoot in Mumbai gives couples a setting that feels elegant, scenic and naturally memorable. Instead of choosing a crowded outdoor location or a predictable studio backdrop, a private yacht creates a more exclusive and visually beautiful environment for your couple shoot.
            </p>
          </div>

          {/* Right Column Paragraphs */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
               The sea, the skyline, the open deck and the natural light come together to create a premium backdrop that feels cinematic and timeless. Whether you are planning a pre-wedding photoshoot, an engagement shoot, a save-the-date shoot or romantic couple content, a yacht gives you a setting that stands out.
            </p>
            <p className="clsm-mid-paragraph">
              With Indiaboats, your pre-wedding yacht photoshoot in Mumbai feels more private, more refined and more experience-led from the start.
            </p>
          </div>
        </div>

        {}
        <div className="clsm-mid-footer">
          <div className="clsm-mid-highlight-badge">
            {/* Highly customized premium dynamic wave-and-breeze sailing wind icon */}
            <svg 
              className="clsm-mid-badge-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M2 10h12a4 4 0 0 1 0 8H12" />
              <path d="M20 10a4 4 0 0 0-4-4H4" />
              <path d="M5 14h14a3 3 0 0 0 0-6H14" />
            </svg>
            <span className="clsm-mid-badge-text">
             Sea views, soft light, and timeless couple moments.
            </span>
          </div>
        </div>

      </div>

      </section>

       <section className="ycf-premium-wrapper">
      <div className="ycf-premium-container">
        
        {}
        <div className="ycf-premium-header">
          <h2 className="rse-section-title">
          Why a Yacht Is a Beautiful Backdrop for a <br /> {" "}
        <span className="rse-serif-italic">
          Pre-Wedding Photoshoot
        </span>
      </h2>
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>
          
          <div className="ycf-premium-intro-split">
            <p className="ycf-intro-lead">
             A yacht photoshoot feels special because the setting itself adds elegance and atmosphere to every frame. The open water creates a sense of freedom, the skyline adds depth and the yacht deck gives your photos a premium and polished look.
            </p>
            <p className="ycf-intro-sub">
             Unlike standard photoshoot locations, a private yacht allows you to move at a more relaxed pace and create intimate moments without the distraction of crowds. The result is a pre-wedding shoot that feels more personal, more stylish and more memorable.
            </p>
          </div>
        </div>

        {}
        <div className="ycf-staggered-grid">
          
          {/* Card 1: More Private */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeDasharray="3 3" />
                <circle cx="12" cy="12" r="4" fill="#ffffff" fillOpacity="0.2" />
                <path d="M12 8v8M8 12h8" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Private</h3>
            <p className="ycf-card-paragraph">
              A private yacht gives you a quieter and more intimate setting for couple photography.
            </p>
          </div>

          {/* Card 2: More Scenic */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M2 17h20M2 20h20" />
                <path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                <path d="M12 2v2M4.22 4.22l1.42 1.42M19.78 4.22l-1.42 1.42" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Scenic</h3>
            <p className="ycf-card-paragraph">
              Sea views and skyline backdrops make every frame feel stronger and more memorable.
            </p>
          </div>

          {/* Card 3: More Personal */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Elegant</h3>
            <p className="ycf-card-paragraph">
              The yacht setting naturally creates a polished and premium visual feel.
            </p>
          </div>

          {/* Card 4: More Premium */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Distinctive</h3>
            <p className="ycf-card-paragraph">
            Your photos stand out more than a standard studio or public-location shoot.
            </p>
          </div>

        </div>

      </div>
    </section>

      

      <section className="rse-root-wrapper">
  <div className="rse-editorial-container">

    <div className="rse-header-block">
      <h2 className="rse-section-title">
        Things to Do During a{" "}
        <span className="rse-serif-italic">
          Pre-Wedding Yacht Photo Shoot
        </span>
      </h2>

      <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>

      <p className="rse-section-paragraph">
       A pre-wedding yacht photoshoot in Mumbai can include a variety of moods and visual styles depending on your preferred look, outfit changes and the kind of story you want your images to tell.
      </p>
    </div>

    <div className="rse-outcomes-list">
      {outcomes.map((item, index) => (
        <div key={index} className="rse-outcome-list-item">
          <div className="rse-item-main-content">

            <div className="rse-icon-circle">
              {item.icon}
            </div>

            <div className="rse-text-stack">
              <h3 className="rse-item-title">{item.text}</h3>
              <p className="rse-item-desc">{item.description}</p>
            </div>

          </div>
        </div>
      ))}
    </div>

  </div>
</section>

     <section className="wefl-pre-root-wrapper">
  <div className="wefl-pre-editorial-container">
    <div className="wefl-pre-split-layout">
      {/* Left Column: Rich Editorial Copy */}
      <div className="wefl-pre-narrative-column">
        <div className="wefl-pre-header-block">
          <h2 className="wefl-pre-section-title">
            What the Experience{" "}
            <span className="wefl-pre-serif-italic">Feels Like</span>
          </h2>
         
        </div>

        <div className="wefl-pre-text-block wefl-pre-highlight-block">
          <div className="wefl-pre-accent-stripe"></div>
          <p className="wefl-pre-paragraph-lead">
            A pre-wedding yacht shoot feels calm, private and visually special. Once onboard, the atmosphere immediately feels different from a normal photoshoot location. The changing sea views, natural movement of the water and open-air setting give your photos a softer and more organic feel.
          </p>
        </div>

        <div className="wefl-pre-text-block">
          <p className="wefl-pre-paragraph">
            For many couples, the experience is not only about the final photos, but also about enjoying meaningful time together while creating them. With Indiaboats, the focus is on making the overall experience feel smooth, scenic and memorable.
          </p>
        </div>

        

        {/* Features */}
      <div className="wefl-pre-features-list">
  <div className="wefl-pre-feature-item">
    <Users size={18} className="wefl-pre-feature-icon" />
    <span>Family-Friendly Experience</span>
  </div>

  <div className="wefl-pre-feature-item">
    <PartyPopper size={18} className="wefl-pre-feature-icon" />
    <span>Private Family Celebrations</span>
  </div>

  <div className="wefl-pre-feature-item">
    <Waves size={18} className="wefl-pre-feature-icon" />
    <span>Scenic Sea Views</span>
  </div>
</div>
      </div>

      {/* Right Column */}
      <div className="wefl-pre-image-column">
        <div className="wefl-pre-image-wrapper">
          <img
            className="wefl-pre-main-image"
            src="/assets/img/prewedding4.png"
            alt="Birthday and anniversary celebration on a luxury yacht in Mumbai"
          />

          <div className="wefl-pre-floating-badge">
            <span className="wefl-pre-badge-title">Private Yacht Experience</span>
            <span className="wefl-pre-badge-subtitle">
              Celebrate on the Sea
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <section className="csrb-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Why Plan Your Pre-Wedding Shoot   <span className="csrb-serif-italic">with Indiaboats</span>
            </h2>
            
            <p className="csrb-lead-paragraph">
              Indiaboats offers premium yacht experiences in Mumbai and helps couples choose the right format for a romantic and visually beautiful pre-wedding photoshoot. We understand that couples are not just booking a location — they are creating memories, wedding content and moments they will look back on for years.
            </p>

            <p className="csrb-lead-paragraph">
              That is why we focus on the overall experience, the setting and the comfort of the couple. From choosing the right yacht style to helping you understand which option suits your shoot best, Indiaboats makes the experience feel easier and more refined.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

     <section className="wyor-root-wrapper">
  <div className="wyor-container">

    <div className="wyor-header">
  <h2 className="rse-section-title">
    Which Yacht Option Is <br />{" "}
    <span className="rse-serif-italic">
      Right for Your Pre-Wedding Shoot
    </span>
  </h2>

  <div className="wyor-accent-wave">
    <svg viewBox="0 0 100 10" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 5 Q 25 0, 50 5 T 100 5"
        stroke="#113d48"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  </div>

  <p className="wyor-lead-copy">
    The right yacht for a pre-wedding shoot usually depends on the visual style
    you want, the number of people joining the shoot and how intimate or
    premium you want the experience to feel.
  </p>
</div>

    <div className="wyor-comparison-grid">

      {/* OPTION 1 */}
      <div className="wyor-card wyor-card-left">

        <div className="wyor-card-canopy wyor-canopy-left">
          <div className="wyor-badge-capsule">
            <span className="wyor-badge-pulse"></span>
            Up to 15 Guests
          </div>

          <div className="wyor-vessel-icon-box">
            <svg
              className="wyor-svg-icon"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 42C24 42 26 38 38 38C50 38 52 42 52 42L48 48H16L12 42Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M22 38L28 16L38 38"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28 16H34L32 24H26L28 16Z"
                fill="rgba(255,255,255,0.2)"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <path
                d="M6 50C18 50 22 48 34 48C46 48 50 50 62 50"
                stroke="rgba(255,255,255,0.4)"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="wyor-card-body">
  <div className="wyor-keel-line"></div>
  <h3 className="wyor-card-title">Private Yacht Charter</h3>
  <div className="wyor-divider-line"></div>

  <p className="wyor-card-paragraph">
    If your pre-wedding shoot is mainly for the couple and a small creative
    team, a Private Yacht Charter is usually the best option. It offers a
    quieter environment, greater privacy and a more personal experience on the
    water.
  </p>
</div>
      </div>

      {/* OPTION 2 */}
      <div className="wyor-card wyor-card-right">

        <div className="wyor-card-canopy wyor-canopy-right">
          <div className="wyor-badge-capsule">
            <span className="wyor-badge-pulse"></span>
            More than 15 Guests
          </div>

          <div className="wyor-vessel-icon-box">
            <svg
              className="wyor-svg-icon"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 42C20 42 24 36 36 36C48 36 52 42 56 42L52 50H12L8 42Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M16 36V28H46V36"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M24 28V22H40V28"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <circle cx="32" cy="25" r="1.5" fill="#ffffff" />
              <circle
                cx="24"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <circle
                cx="32"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <circle
                cx="40"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <path
                d="M6 52C18 52 22 50 34 50C46 50 50 52 62 52"
                stroke="rgba(255,255,255,0.4)"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="wyor-card-body">
  <div className="wyor-keel-line"></div>
  <h3 className="wyor-card-title">Larger Yacht Option</h3>
  <div className="wyor-divider-line"></div>

  <p className="wyor-card-paragraph">
    If your shoot includes a larger production team, family involvement or a
    bigger styled setup, you may want to explore a larger yacht option. The
    additional space provides greater flexibility for photography, videography
    and creative direction.
  </p>
</div>
      </div>

    </div>
  </div>
</section>

      <section className="pfUniqueMainSection" id="birtday_perfect_for">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: "2rem" }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
  "Pre-wedding yacht photoshoot in Mumbai",
  
  "Engagement photoshoot on a yacht",
  "Save-the-date photos and video content",
  "Romantic anniversary-style shoots",
  "Luxury wedding content creation",
  "Sunset couple shoot on the water",
].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>

<div className="pyc-wrapper">
     <div className="pyc-container">
        
        {/* Main Section Header */}
        <div className="pyc-header">
         
          <h2 className="rse-section-title">
        Tailored Party {" "}
        <span className="rse-serif-italic">
          Yacht Experiences
        </span>
      </h2>
          
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>
        </div>

        {}
        <div className="pyc-unified-box">
          
          {/* Left Side: Up to 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/prewedding2.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Intimate Gatherings</span>
                <h3 className="pyc-card-title">Pre-Wedding Yacht Photoshoot for Smaller Groups</h3>
                <p className="pyc-card-copy">
                 For most couples, a private yacht charter is the best option for a pre-wedding photoshoot in Mumbai. It creates a more intimate, relaxed and visually elegant setting for the couple, photographer and a small support team.
                </p>
              </div>
            </div>
            
            <a href="private-yacht-charter-mumbai-goa" className="pyc-cta" aria-label="Explore Private Yacht Charters for Up to 15 Guests">
              <span className="pyc-cta-text">
                Explore Private Yacht Charters for Couple Shoots
              </span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

          {/* Elegant Dividing Line */}
          <div className="pyc-vertical-divider"></div>

          {/* Right Side: More Than 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/prewedding3.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                  <line x1="4" y1="22" x2="4" y2="15" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Grand Events</span>
                <h3 className="pyc-card-title">Larger Yacht Options for Bigger Shoot Setups</h3>
                <p className="pyc-card-copy">
                 If your pre-wedding yacht shoot includes a larger group, more people onboard or a styled setup with additional support, a larger yacht option may be more suitable to create better space and movement during the experience.
                </p>
              </div>
            </div>
            
            <a href="yacht-party-mumbai" className="pyc-cta" aria-label="Explore Private Yacht Parties for More Than 15 Guests">
              <span className="pyc-cta-text">Explore Larger Yacht Options</span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

        </div>
      </div>
</div>

       <section className="wtei-section">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          {/* Left Column: Title and Narrative Copy */}
          <div className="wtei-col-left">
             <h2 className="rse-section-title">
        What to Expect {" "}
        <span className="rse-serif-italic">
         with Indiaboats
        </span>
      </h2>
            <p className="wtei-paragraph">
              When you plan a pre-wedding yacht photoshoot with Indiaboats, the experience is designed to feel premium, simple and memorable. We help you understand which type of yacht suits your vision, what kind of format works best for your shoot and how to create a couple experience that feels both special and visually strong.
            </p>
          
          </div>

          { }
          {/* Right Column: Inclusions Style List */}
          <div className="wtei-col-right">
        <ul className="wtei-list">
  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Premium yacht photoshoot setting
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Guidance based on couple shoot requirements
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Suitable options for intimate and larger setups
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Scenic sea views and elegant backdrop
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      More exclusive than standard photoshoot locations
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Supportive and experience-led planning
    </span>
  </li>
</ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every yacht experience. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so your pre-wedding yacht photoshoot in Mumbai feels enjoyable, comfortable and professionally managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  pageKey="pre-wedding-yacht-photoshoot-mumbai"
  title="Frequently Asked Questions About Pre-Wedding Yacht Photo Shoots"
  faqData={prewedFaqs}
/>
     
             <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Shoot</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Shoot Type</label>
      <select>
      <option>Select celebration type</option>
<option>Prewedding Celebration</option>
<option>Anniversary Celebration</option>
<option>Milestone Birthday</option>
<option>Engagment Celebration</option>
<option>Couple Celebration</option>

<option>Surprise Celebration</option>
<option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

        
      <Footer />
    </div>
  );
};

export default PreWedding;
